import { Select } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

/**
 * The key of the filter. Must be equal to the column field.
 */
export const FILTER_KEY = 'isRequired' as const;

/**
 * The options of the filter.
 */
export const OPTIONS = [
  { value: 'y', label: 'Povinné' },
  { value: 'n', label: 'Nepovinné' },
];

/**
 * Parameters of the EvidenceFieldRequiredSelectFilter component.
 */
export interface EvidenceFieldRequiredSelectFilterProps {
  api: GridApi;
  onChange: FilterChangeCallback;
}

/**
 * Filter component for the isRequired column.
 *
 * This filter assumes:
 * - column field is `isRequired`
 */
export default function EvidenceFieldRequiredSelectFilter({ api, onChange }: EvidenceFieldRequiredSelectFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: FILTER_KEY, onChange });

  return (
    <Select
      searchable
      clearable
      w="100%"
      size="sm"
      placeholder="Všetky polia"
      data={OPTIONS}
      value={value}
      onChange={setValue}
    />
  );
}
